//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import { isNil } from 'lodash';
dayjs.locale('zh-cn');
dayjs.extend(relativeTime);
dayjs.extend(LocalizedFormat);
export default {
  filters: {
    getTime(val) {
      return dayjs(val * 1000).format('lll');
    },
  },
  data() {
    return {
      objectId: null,
      object: null,
      // 表单
      searchForm: {
        serch: '',
        page: 1,
        pageSize: 10,
      },
      // 表格
      loading: false,
      allData: [],
      allFilterList: [],
      // 删除弹窗
      delDialog: {
        id: null,
        visible: false,
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      return {
        metaManage: this.getElementList.includes('meta-manage'),
      };
    },
    list() {
      const offset = (this.searchForm.page - 1) * this.searchForm.pageSize;
      return this.allFilterList.slice(offset, offset + this.searchForm.pageSize);
    },
  },
  created() {
    this.objectId = this.$route.query.object_id;
    this.object = this.$route.query.object;
    if (!this.object) {
      this.$message.error('缺少必要参数');
      this.$router.go(-1);
      return;
    }
    this.getList();
  },
  methods: {
    searchList() {
      this.searchForm.page = 1;
      this.getList();
    },
    resetForm() {
      this.$refs.searchForm.resetFields();
      this.searchList();
    },
    async getList() {
      this.loading = true;
      try {
        const { rules } = await this.$request({
          url: this.$api.getValidateRules,
          data: {
            object: this.object,
          },
        });
        this.allData = rules;
        this.getFilterData();
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.allData = [];
        this.getFilterData();
        this.loading = false;
      }
    },
    getFilterData() {
      if (this.searchForm.serch) {
        this.allFilterList = this.allData.filter((item) => {
          return item.name.includes(this.searchForm.serch);
        });
        return;
      }
      this.allFilterList = this.allData;
    },
    // 翻页器
    handleCurrentChange(val) {
      this.searchForm.page = val;
      //   this.getList();
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.searchForm.page = 1;
      //   this.getList();
    },
    // 表格
    async changeStatus(row, type) {
      try {
        await this.$confirm(`确定${type}该数据(${row.name})?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        this.$message({
          type: 'success',
          message: `${type}成功!`,
        });
        // 调用接口
        await this.$request({
          url: this.$api.enableValidateRule,
          data: {
            version: row.version,
            id: row.id,
            is_active: !row.enable,
          },
        });
        this.getList();
      } catch (err) {
        console.log(err);
      }
    },
    edit(rule_id, version) {
      const pramas = rule_id ? { rule_id } : {};
      if (!isNil(version)) {
        pramas.version = version;
      }
      this.$router.push({
        name: 'rule-edit',
        query: {
          ...pramas,
          object_id: this.objectId,
          object: this.object,
        },
      });
    },
    del({ id }) {
      this.delDialog.id = id;
      this.delDialog.visible = true;
    },
    // 弹窗关闭
    handleClose() {
      this.delDialog.visible = false;
    },
    async confirmDelete() {
      try {
        await this.$request({
          url: this.$api.deleteValidateRule,
          data: {
            id: this.delDialog.id,
          },
        });
        this.handleClose();
        this.searchList();
      } catch (err) {
        console.log(err);
      }
    },
  },
};
